import ApiService from "@/api.service";
import API from "@/API";

export const GET_LIST_SHOWROOM = "listStores";
export const GET_DETAIL_SHOWROOM = "detailStore";
export const SAVE_SHOWROOM = "saveStore";
export const UPDATE_SHOWROOM = "updateStore";
export const DELETE_SHOWROOM = "deleteStore";
export const UPLOAD_SHOWROOM_IMAGE = "uploadStore";
export const GET_DATA_SEARCH = "getDataSearchStores";
export const SET_DATA_SEARCH = "setDataSearchStores";
export const SET_LIST_SHOWROOM = "setListStore";
export const SET_DETAIL_SHOWROOM = "setDetailStore";
export const IMPORT_EXCEL_SHOWROOM = "importStore";
export const UPDATE_ORDER_SHOWROOM = "updateOrderStore";
export const EXPORT_EXCEL_SHOWROOM = "exportStore";

export const DETAIL_CONFIG_SHOWROOM = "detailConfigShowroom";
export const SET_DETAIL_CONFIG_SHOWROOM = "setDetailConfigShowroom";
export const UPDATE_CONFIG_TYPE_SHOWROOM = "updateConfigShowroom";


const state = {
    showrooms: [],
    showroom: {},
    dataSearch: [],
    config_type_showroom: [],
};

const getters = {
    showrooms(state) {
        return state.showrooms;
    },
    showroom(state) {
        return state.showroom;
    },
    dataSearchStores(state) {
        return state.dataSearch;
    },
    config_type_showroom(state) {
        return state.config_type_showroom;
    },
};

const actions = {
    [UPDATE_CONFIG_TYPE_SHOWROOM](context, payload) {
        return new Promise(resolve => {
            ApiService.put(API.UPDATE_CONFIG_TYPE_SHOWROOM, payload).then(({ data }) => {
                resolve(data);
            });
        });
    },
    [DETAIL_CONFIG_SHOWROOM](context) {
        return new Promise(resolve => {
            ApiService.query(API.DETAIL_CONFIG_SHOWROOM).then(({ data }) => {
                if (data) {
                    context.commit(SET_DETAIL_CONFIG_SHOWROOM, data);
                }
                resolve(data);
            });
        });
    },
    [GET_LIST_SHOWROOM](context) {
        return new Promise(resolve => {
            ApiService.query(API.GET_LIST_SHOWROOM).then(({ data }) => {
                if (data.status) {
                    context.commit(SET_LIST_SHOWROOM, data);
                }
                resolve(data);
            });
        });
    },
    [GET_DATA_SEARCH](context, payload) {
        return new Promise(resolve => {
            ApiService.query(API.GET_LIST_STORE_SEARCH, payload).then(({ data }) => {
                if (data.status) {
                    context.commit(SET_DATA_SEARCH, data.data.stores);
                }
                resolve(data);
            });
        });
    },

    [GET_DETAIL_SHOWROOM](context, id) {
    return new Promise(resolve => {
    ApiService.query(`${API.GET_DETAIL_SHOWROOM}/${id}`).then(({data}) => {
    if (data.status) {
    context.commit(SET_DETAIL_SHOWROOM, data);
    }
    resolve(data);
    });
    });
    },
    [UPLOAD_SHOWROOM_IMAGE](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`${API.UPLOAD_SHOWROOM_IMAGE}`, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    [IMPORT_EXCEL_SHOWROOM](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`${API.IMPORT_EXCEL_SHOWROOM}`, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    [EXPORT_EXCEL_SHOWROOM](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.download(`${API.EXPORT_EXCEL_SHOWROOM}`, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    [SAVE_SHOWROOM](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`${API.SAVE_SHOWROOM}`, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    [UPDATE_SHOWROOM](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.update(`${API.UPDATE_SHOWROOM}`, payload.id, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    [UPDATE_ORDER_SHOWROOM](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.put(`${API.UPDATE_ORDER_SHOWROOM}/${payload.id}/order`, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    [DELETE_SHOWROOM](context, id) {
        return new Promise((resolve, reject) => {
            ApiService.delete(`${API.DELETE_SHOWROOM}`, id)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
};

const mutations = {
    [SET_DETAIL_CONFIG_SHOWROOM](state, data) {
        state.config_type_showroom = data.data;
    },
    [SET_LIST_SHOWROOM](state, data) {
        state.showrooms = data.data;
    },
    [SET_DETAIL_SHOWROOM](state, data) {
        state.showroom = data.data;
    },
    [SET_DATA_SEARCH](state, data) {
        state.dataSearch = data
    }
};

export default {
    state,
    actions,
    mutations,
    getters
};